import { useNavigate } from "react-router-dom";

export const UnauthorizedPage = () => {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={styles.errorCode}>401</div>
                <div style={styles.errorMessage}>🔒 Unauthorized Access</div>
                <div style={styles.text}>
                    Oops! You don't have permission to view this page.
                </div>
               
            </div>
        </div>
    )
}

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        padding: '20px',
    },
    content: {
        textAlign: 'center',
        maxWidth: '600px',
        padding: '40px',
        borderRadius: '10px',
        backgroundColor: 'white',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    errorCode: {
        fontSize: '120px',
        fontWeight: 'bold',
        color: '#dc3545',
        lineHeight: 1,
        marginBottom: '20px',
    },
    errorMessage: {
        fontSize: '32px',
        color: '#2d2d2d',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
    },
    text: {
        fontSize: '18px',
        color: '#6c757d',
        margin: '20px 0',
        lineHeight: 1.6,
    },
    button: {
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        padding: '12px 30px',
        fontSize: '16px',
        borderRadius: '5px',
        cursor: 'pointer',
        marginTop: '20px',
        transition: 'background-color 0.3s ease',
        textTransform: 'uppercase',
        fontWeight: '600',
        letterSpacing: '1px',
    }
}